/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/ContactInfo/Phone/Phones/Content/Phone/Number/Related/Empty"
  
}) {
  return null
}